import { render } from "./TvmSlideOutBbTradeValue.vue?vue&type=template&id=0d3f06d0&scoped=true"
import script from "./TvmSlideOutBbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutBbTradeValue.vue?vue&type=script&lang=js"

import "./TvmSlideOutBbTradeValue.vue?vue&type=style&index=0&id=0d3f06d0&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3f06d0"],['__file',"src/Components/ChatWidget/SlideOutPanel/TvmSlideOutBbTradeValue/TvmSlideOutBbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d3f06d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d3f06d0', __exports__)) {
    api.reload('0d3f06d0', __exports__)
  }
  
  module.hot.accept("./TvmSlideOutBbTradeValue.vue?vue&type=template&id=0d3f06d0&scoped=true", () => {
    api.rerender('0d3f06d0', render)
  })

}


export default __exports__